// extracted by mini-css-extract-plugin
module.exports = {"card-header":"Tags_card-header__uBDrs","actions":"Tags_actions__2I7_S","table-name":"Tags_table-name__3l49k"};